// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RunServerCommand: MarkdocTagRegistration = {
  tag: 'run-server-command',
  component: 'RunServerCommand',
  selfClosing: true,
  attributes: {
    route: {
      type: String,
    },
  },
};
